module.exports = __webpack_public_path__ + "img/warnellforestry-h-474x356.5aa165a5.jpg";